/** @jsxImportSource hono/jsx/dom */
import { render } from 'hono/jsx/dom'
import { fetchWordState, readWordState, wordPath, type WordState } from './api'
import { RegisterWidget } from './RegisterWidget'
import { navigate, setNavigationHandler } from './router'
import { SearchWidget } from './SearchWidget'
import { WordApp } from './WordApp'

const siteKey = document.body.dataset.siteKey ?? ''
const appRoot = document.getElementById('app-root')
const wordAppElement = document.getElementById('word-app')

/** #app-root を単語画面のコンポーネントで置き換える */
function mountWordApp(initial: WordState, push: boolean): void {
  if (!appRoot) {
    location.assign(wordPath(initial.word))
    return
  }
  render(<WordApp initial={initial} siteKey={siteKey} />, appRoot)
  document.title = `${initial.word} の読み方 - YOMIKATA`
  if (push) history.pushState({ word: initial.word }, '', wordPath(initial.word))
  window.scrollTo({ top: 0 })
}

if (wordAppElement && appRoot) {
  // 単語画面: サーバーが描いた内容をそのまま初期状態にする
  mountWordApp(readWordState(wordAppElement), false)
} else {
  // ホーム画面など: 最初の遷移で単語画面のコンポーネントに差し替える
  // (以降のナビゲーションは WordApp 自身が引き取る)
  setNavigationHandler((word, options) => {
    if (options.state) {
      mountWordApp(options.state, options.push)
      return
    }
    fetchWordState(word)
      .then((state) => mountWordApp(state, options.push))
      .catch(() => location.assign(wordPath(word)))
  })
}

const searchContainer = document.getElementById('search-widget')
if (searchContainer) render(<SearchWidget />, searchContainer)

const registerContainer = document.getElementById('register-widget')
if (registerContainer) {
  render(
    <RegisterWidget siteKey={siteKey} initialWord={wordAppElement?.dataset.word ?? ''} />,
    registerContainer
  )
}

// ランキング・新着・ホームの単語リンクも画面遷移なしで開く
document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0) return
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
  const target = event.target as HTMLElement | null
  const link = target?.closest?.('[data-word-link]')
  const word = link?.getAttribute('data-word-link')
  if (!word) return
  event.preventDefault()
  navigate(word)
})

window.addEventListener('popstate', () => {
  const path = location.pathname
  if (path === '/' || path === '') {
    // ホームはサーバー描画のまま使う
    location.reload()
    return
  }
  let word: string
  try {
    word = decodeURIComponent(path.slice(1))
  } catch {
    location.reload()
    return
  }
  navigate(word, { push: false })
})
